import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  listingBegin,
  listingSuccess,
  listingErr,

  listingDeleteBegin,
  listingDeleteErr,
  listingDeleteSuccess,

  listingDetailBegin,
  listingDetailErr,
  listingDetailSuccess,

  createOrUpdateListingBegin,
  createOrUpdateListingSuccess,
  createOrUpdateListingErr,

  hostPartnerCoverageBegin,
  hostPartnerCoverageSuccess,
  hostPartnerCoverageErr,

  downloadQrcodeBegin,
  downloadQrcodeSuccess,
  downloadQrcodeErr,

  listingContentBegin,
  listingContentSuccess,
  listingContentErr,

  chatStatusBegin,
  chatStatusSuccess,
  chatStatusErr,

  exportListingDataBegin,
  exportListingDataSuccess,
  exportListingDataErr,

  nearbyPlacesBegin,
  nearbyPlacesSuccess,
  nearbyPlacesErr,

  fetchThemebyHostBegin,
  fetchThemebyHostSuccess,
  fetchThemebyHostErr,

  listingKnowledgeBaseDetailsBegin,
  listingKnowledgeBaseDetailsSuccess,
  listingKnowledgeBaseDetailsErr,

  smartTvPairingCodeBegin,
  smartTvPairingCodeSuccess,
  smartTvPairingCodeErr,


  smartTvUnlinkBegin,
  smartTvUnlinkSuccess,
  smartTvUnlinkErr,

  downloadRentalAgreementPdfBegin,
  downloadRentalAgreementPdfSuccess,
  downloadRentalAgreementPdfErr,

} = actions;

const ListingListAPI = '/admin/listing-list';
const GetListingDetailAPI = '/admin/listing-detail/';
const DeleteListing = '/admin/delete-listing/';
const CreateOrUpdateListingAPI = '/admin/add-edit-listing';
const GetListingSlugAPI = '/admin/get-slug';
const HostPartnerCoverageAPI = '/admin/host-partner-coverage/';
const generateQrCodeAPI = 'generate-qr-code/';
const listingContent = '/admin/get-listing-content';
const getChatStatus = '/admin/get-chat-status/';
const exportListingDataAPI = '/admin/export-listing-data';
const coptListingAPI = '/admin/copy-listing';
const getNearbyPlacesAPI = '/admin/nearby-places';
const importPMSListingAPI = '/admin/import-pms-listings';
const fetchThemebyHostAPI = '/admin/get-configurations';
const GetListingKnowledgeBaseDetailsAPI = '/admin/listing-knowledge-base-details/';
const SmartTvPairingCodeAPI = '/admin/smart-tv-pairing-code/';
const SmartTvUnlinkAPI = '/admin/smart-tv-unlink/';
const downloadRentalAgreementPdfAPI = '/admin/download-rental-agreement-pdf/';

const listingList = (values) => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.post(ListingListAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data?.result;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const getListingDetail = (values) => {
  return async (dispatch) => {
    dispatch(listingDetailBegin());
    try {
      const response = await DataService.get(GetListingDetailAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDetailErr(response?.data?.message));
      } else {
        dispatch(listingDetailSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const getHostPartnerCoverage = (values) => {
  return async (dispatch) => {
    dispatch(hostPartnerCoverageBegin());
    try {
      const response = await DataService.get(HostPartnerCoverageAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(hostPartnerCoverageErr(response?.data?.message));
      } else {
        dispatch(hostPartnerCoverageSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(hostPartnerCoverageErr(err));
    }
  };
};

const listingDelete = (values) => {
  return async (dispatch) => {
    dispatch(listingDeleteBegin());
    try {
      const response = await DataService.delete(DeleteListing + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDeleteErr(response?.data?.message));
      } else {
        dispatch(listingDeleteSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingDeleteErr(err));
    }
  };
};

const creatOrUpdateListing = (values, callback) => {
  return async (dispatch) => {
    dispatch(createOrUpdateListingBegin());
    try {
      const response = await DataService.post(CreateOrUpdateListingAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(createOrUpdateListingErr(response?.data?.message));
      } else {
        dispatch(createOrUpdateListingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(createOrUpdateListingErr(err));
    }
  };
};

const getListingSlug = () => {
  return async (dispatch) => {
    dispatch(listingDetailBegin());
    try {
      const response = await DataService.get(GetListingSlugAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDetailErr(response?.data?.message));
      } else {
        dispatch(listingDetailSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};


const downloadQrCode = (listingSlug, actionType) => {
  return async (dispatch) => {
    dispatch(downloadQrcodeBegin());
    try {
      const endPoint = `${process.env.REACT_APP_API_ENDPOINT}generate-qr-code/${listingSlug}?action_type=${actionType}`;
      window.open(endPoint, '_blank');
    } catch (err) {
      dispatch(downloadQrcodeErr(err));
    }
  };
};

const downloadRentalAgreementPdfWithContent = (listingSlug, type, rentalInstructions = null) => {
  return async (dispatch) => {
    dispatch(downloadRentalAgreementPdfBegin());
    try {
      const payload = { type };
      if (rentalInstructions !== null) {
        payload.rental_instructions = rentalInstructions;
      }
      const response = await DataService.export(`${downloadRentalAgreementPdfAPI}${listingSlug}`, payload);
      if (response?.status === HttpStatus.HTTP_UNPROCESSABLE_ENTITY && response?.data instanceof Blob) {
        const errorText = await response.data.text();
        const errorData = JSON.parse(errorText);
        dispatch(downloadRentalAgreementPdfErr(errorData?.message));
        return errorData;
      }
      return response;
    } catch (err) {
      dispatch(downloadRentalAgreementPdfErr(err));
    }
  };
};

const getListingContent = () => {
  return async (dispatch) => {
    dispatch(listingContentBegin());
    try {
      const response = await DataService.get(listingContent);
      if (response?.data?.status === HttpStatus.HTTP_OK) {
        dispatch(listingContentSuccess(response));
      }
      return response?.data?.result;
    } catch (err) {
      dispatch(listingContentErr(err));
    }
  };
};

const getChatEnableStatus = (values) => {   // chat enable status
  return async (dispatch) => {
    dispatch(chatStatusBegin());
    try {
      const response = await DataService.get(getChatStatus  + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(chatStatusErr(response?.data?.message));
      } else {
        dispatch(chatStatusSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(chatStatusErr(err));
    }
  };
};

const exportListingData = (values) => {
  return async (dispatch) => {
    dispatch(exportListingDataBegin());
    try {
      const response = await DataService.export(exportListingDataAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(exportListingDataErr(response?.data?.message));
      } else {
        dispatch(exportListingDataSuccess(response?.data));
      }
      return response;
    } catch (err) {
      dispatch(exportListingDataErr(err));
    }
  };
};


const copyListingData = (values) => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.post(coptListingAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

/* google map api for nearby places */
const getNearbyPlaces = () => {
  return async (dispatch) => {
    dispatch(nearbyPlacesBegin());
    try {
      const response = await DataService.post(getNearbyPlacesAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(nearbyPlacesErr(response?.data?.message));
      } else {
        dispatch(nearbyPlacesSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(nearbyPlacesErr(err));
      return [];
    }
  }
};

const importPMSListing = () => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.get(importPMSListingAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const fetchThemebyHost = (values) => {
  return async (dispatch) => {
    dispatch(fetchThemebyHostBegin());
    try {
      const response = await DataService.post(fetchThemebyHostAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(fetchThemebyHostErr(response?.data?.message));
      } else {
        dispatch(fetchThemebyHostSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(fetchThemebyHostErr(err));
    }
  };
};

const getListingKnowledgeBaseDetails = (listingSlug) => {
  return async (dispatch) => {
    dispatch(listingKnowledgeBaseDetailsBegin());
    try {
      const response = await DataService.get(GetListingKnowledgeBaseDetailsAPI + listingSlug);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingKnowledgeBaseDetailsErr(response?.data?.message));
      } else {
        dispatch(listingKnowledgeBaseDetailsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingKnowledgeBaseDetailsErr(err));
    }
  };
};

const getSmartTvPairingCode = (listingSlug) => {
  return async (dispatch) => {
    dispatch(smartTvPairingCodeBegin());
    try {
      const response = await DataService.post(SmartTvPairingCodeAPI + listingSlug);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(smartTvPairingCodeErr(response?.data?.message));
      } else {
        dispatch(smartTvPairingCodeSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(smartTvPairingCodeErr(err));
    }
  };
};

const unlinkSmartTv = (deviceSlug) => {
  return async (dispatch) => {
    dispatch(smartTvUnlinkBegin());
    try {
      const response = await DataService.post(SmartTvUnlinkAPI + deviceSlug);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(smartTvUnlinkErr(response?.data?.message));
      } else {
        dispatch(smartTvUnlinkSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(smartTvUnlinkErr(err));
    }
  };
};

export { listingList, getListingDetail, listingDelete, creatOrUpdateListing, getListingSlug, getHostPartnerCoverage, downloadQrCode, getListingContent, exportListingData, copyListingData, getChatEnableStatus, getNearbyPlaces, importPMSListing ,fetchThemebyHost, getListingKnowledgeBaseDetails, getSmartTvPairingCode, unlinkSmartTv, downloadRentalAgreementPdfWithContent };
